import { render } from "./Typography.vue?vue&type=template&id=4ab00096&scoped=true"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "@complispace/cs-apex-definitions/dist/css/typography.css?vue&type=style&index=0&id=4ab00096&scoped=true&module=true&lang=css"
cssModules["$style"] = style0
import "./Typography.vue?vue&type=style&index=1&id=4ab00096&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-4ab00096"]])

export default __exports__